import TypesInternal from "@prismicio/types-internal/lib/customtypes/index.js";
import * as z from "zod";
const CustomTypeSchema = z.unknown().transform((val, ctx) => {
  const result = TypesInternal.CustomType.decode(val);
  if (result._tag === "Right") {
    return result.right;
  }
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message: "Invalid custom type."
  });
  return z.NEVER;
});
const SharedSliceSchema = z.unknown().transform((val, ctx) => {
  const result = TypesInternal.SharedSlice.decode(val);
  if (result._tag === "Right") {
    return result.right;
  }
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message: "Invalid shared slice."
  });
  return z.NEVER;
});
export {
  CustomTypeSchema,
  SharedSliceSchema
};
//# sourceMappingURL=typesInternalSchemas.js.map
